import { render, staticRenderFns } from "./WindowFilaTab.vue?vue&type=template&id=3ec63c2e"
import script from "./WindowFilaTab.vue?vue&type=script&lang=js"
export * from "./WindowFilaTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports